// Elite Look — JS propio (vanilla, sin librerías externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initSelectorVariantes();
});

/* ---------------- Reveal al hacer scroll ---------------- */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-reveal-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

/* ---------------- Galería de producto (miniaturas) ---------------- */
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-media-principal]');
    var thumbs = galeria.querySelectorAll('[data-mt-thumb]');
    if (!principal || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!src) return;
        principal.src = src;
        principal.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

/* ---------------- Selector de variantes (producto) ---------------- */
function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var opcionesBotones = form.querySelectorAll('[data-mt-opcion-valor]');

    function opcionesSeleccionadas() {
      var seleccion = {};
      var grupos = {};
      form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
        var nombre = grupo.getAttribute('data-mt-opcion');
        var activo = grupo.querySelector('.is-selected');
        if (activo) seleccion[nombre] = activo.getAttribute('data-mt-opcion-valor');
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (val, i) {
          var nombre = v.optionNames ? v.optionNames[i] : null;
          return nombre ? seleccion[nombre] === val : true;
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) {
        precioEl.innerHTML = variante.compare_at_price && variante.compare_at_price > variante.price
          ? '<s>' + formatoDinero(variante.compare_at_price) + '</s> ' + formatoDinero(variante.price)
          : formatoDinero(variante.price);
      }
      if (addBtn) {
        addBtn.disabled = !variante.available;
        addBtn.textContent = variante.available
          ? addBtn.getAttribute('data-label-disponible')
          : addBtn.getAttribute('data-label-agotado');
      }
    }

    function formatoDinero(centavos) {
      return '€' + (centavos / 100).toFixed(2).replace('.', ',');
    }

    opcionesBotones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-mt-opcion]');
        grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        actualizar();
      });
    });

    if (variantes.length > 1) actualizar();
  });
}
